import { lazy } from "react";

import AlertDialogPanel from "../components/shared/AlertDialogPanel";
import {
  DateTimeFormats,
  KeyCodes,
  MobileDevices,
  SmartScanOralHealthStatus,
  smartScanCategory,
  MaxAllowdFileSizes,
  FileCompressQuality,
  GenderOptions,
  GroupNumMaxLength,
  CampaignStateSettingTypes,
  ReferralsNotificationTypesRedirectURL,
  SmartScanPerfectScore,
  DiscountTypes,
  DentalDotComUrlParamLinkType,
  SmartScanQuadrantType,
  UtmParams,
  PAGE_TITLES
} from "../constants";
import moment from "moment";
const $ = lazy(() => import("jquery"));
import { confirmAlert } from "react-confirm-alert"; // Import
import No_Preview_available from "../assets/images/No_preview_available.jpg";
import audio_file_icon from "../assets/images/audio_file_icon.png";
import compressed_file_icon from "../assets/images/compressed_file_icon.png";
import presentation_file_icon from "../assets/images/presentation_file_icon.png";
import spreadsheet_file_icon from "../assets/images/spreadsheet_file_icon.png";
import video_file_icon from "../assets/images/video_file_icon.png";
import pdf_file_icon from "../assets/images/pdf_file_icon.png";
import executable_file_icon from "../assets/images/executable_file_icon.png";
import word_processor_file_icon from "../assets/images/word_processor_file_icon.png";
import {
  auditConference_Ajax,
  addDentistDirectReferral_Ajax
} from "./requests";
import { getPatientInfo } from "./authManager";
const platform = lazy(() => import("platform"));
import {
  getApiUrl,
  getBaseUrl,
  getStripePublishableKey,
  isReferralFeatureEnabledForOrigin
} from "../ApplicationSettings";

export const supportedImageExtentions = [
  "dcm",
  "bmp",
  "stl",
  "obj",
  "jpeg",
  "jpg",
  "png",
  "heic",
  "tif",
  "tiff",
  "webp"
];

export const supportedDocExtensions = [
  "pdf",
  "xls",
  "xlsx",
  "csv",
  "doc",
  "docx"
];

export const isPasswordValid = (value) => {
  var lowercaseLetterRex = /[a-z]/;
  var uppercaseLetterRex = /[A-Z]/;
  var digitRex = /\d/;
  var specialCharacterRex = /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/;
  var lengthRex = /[A-Za-z\d !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}/;
  if (value.length == 0) {
    return true;
  } else if (
    lowercaseLetterRex.test(value) &&
    uppercaseLetterRex.test(value) &&
    digitRex.test(value) &&
    specialCharacterRex.test(value) &&
    lengthRex.test(value)
  ) {
    return true;
  } else {
    return false;
  }
};

export const isEmailAddressValid = (email) => {
  if (email.length == 0) {
    return true;
  } else if (
    /^((\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*)\s*[,]{0,1}\s*)+$/.test(
      email
    )
  ) {
    return true;
  } else {
    return false;
  }
};

export const isPhoneNumberValid = (value) => {
  if (value.length == 0) {
    return true;
  } else if (/^(\(\d{3}\))-(\d{3})-(\d{4})(\d*)/.test(value)) {
    return true;
  } else {
    return false;
  }
};

export const toLocalDate = (date) => {
  return moment.utc(date).format(DateTimeFormats.MMM_DD_YYYY);
};

export const toLocalDateTime = (date) => {
  if (date) {
    var dateUtc = moment.utc(date);
    return dateUtc
      .local()
      .format(DateTimeFormats.MMM_DD_YYYY + " " + DateTimeFormats.HH_MM_A);
  }
};

export const getSupportedImageExtensions = () => {
  return supportedImageExtentions.join(", ");
};

export const isImageFile = (source) => {
  if (source) {
    var extension = source.split(".").pop().toLowerCase();

    if (extension) {
      return supportedImageExtentions.includes(extension);
    }
  }
  return false;
};

export const getSupportedDocExtensions = () => {
  return supportedDocExtensions.join(", ");
};

export const isValidDocFileForPatientUpload = (source) => {
  if (source) {
    var extension = source.split(".").pop().toLowerCase();

    if (extension) {
      return supportedDocExtensions.includes(extension);
    }
  }
  return false;
};

export const handleApiErrors = (err) => {};

export const getCurrentDate = (format, patientTimeZone) => {
  if (patientTimeZone) {
    var currentDate = moment.utc();
    var offsetToAdd = toTimezoneOffset(patientTimeZone);
    currentDate.hour(currentDate.hour() + offsetToAdd);
  } else {
    var currentDate = moment();
  }

  if (format) {
    currentDate = currentDate.format(format);
  }

  return currentDate;
};

export const isEqualToCurrentDate = (date) => {
  try {
    var date = moment(date);
    var currentDate = getCurrentDate();

    if (
      currentDate &&
      date &&
      currentDate.year() == date.year() &&
      currentDate.month() == date.month() &&
      currentDate.date() == date.date()
    ) {
      return true;
    }

    return false;
  } catch (ex) {}
};

export const formatDateTime = (date, format) => {
  try {
    var date = moment(date);
    return date.format(format);
  } catch (ex) {}
};

export const getIsoString = (date) => {
  try {
    var date = moment(date);
    return date.toISOString();
  } catch (ex) {}
};

export const formatDateTimeWithZone = (localDate, format) => {
  return (
    formatDateTime(localDate, format) +
    " (" +
    getTimezoneAbbreviation(String(localDate._d)) +
    ")"
  );
};

export const getDSTimezoneName = (offset) => {
  switch (offset) {
    case -4:
      return "EDT";
    case -5:
      return "CDT";
    case -6:
      return "MDT";
    case -7:
      return "PDT";
    case -8:
      return "ADT";
    case -9:
      return "HADT";
    case 0:
      return "GMT";
    default:
      return "UTC " + (offset >= 0 ? "+" : "") + offset;
  }

  return "";
};

export const toTimezoneName = (offset, isDST) => {
  if (isDST) {
    return getDSTimezoneName(offset);
  }

  switch (offset) {
    case -5:
      return "EST";
    case -6:
      return "CST";
    case -7:
      return "MST";
    case -8:
      return "PST";
    case -9:
      return "AST";
    case -10:
      return "HAST";
    case 0:
      return "GMT";
    default:
      return "UTC " + (offset >= 0 ? "+" : "") + offset;
  }

  return "";
};

export const toTimezoneOffset = (timezone) => {
  switch (timezone) {
    case "UTC -4":
      return -4;
    case "UTC -5":
      return -5;
    case "UTC -6":
      return -6;
    case "UTC -7":
      return -7;
    case "UTC -8":
      return -8;
    case "UTC -9":
      return -9;
    case "UTC -10":
      return -10;
    case "UTC +0":
      return 0;
  }
};

export const getTimezoneAbbreviation = (time) => {
  var index = time.indexOf("(");
  var lastIndex = time.indexOf(")");
  var prefixString = "";
  prefixString += time[index + 1];
  while (index < lastIndex) {
    index = time.indexOf(" ", ++index);
    if (index < 0) break;
    prefixString += time[++index];
  }
  return prefixString;
};

export const toLocal = (date) => {
  var date = moment.utc(date);
  return date.local();
};

export const getTimeSince = (date) => {
  date = moment.utc(date);
  var currentDate = getCurrentDate();

  var seconds = Math.floor((currentDate - date) / 1000);

  var interval = Math.floor(seconds / 31536000);

  if (interval > 1) {
    return interval + " years";
  } else if (interval == 1) {
    return interval + " year";
  }
  interval = Math.floor(seconds / 2592000);
  if (interval > 1) {
    return interval + " months";
  } else if (interval == 1) {
    return interval + " month";
  }
  interval = Math.floor(seconds / 86400);
  if (interval > 1) {
    return interval + " days";
  } else if (interval == 1) {
    return interval + " day";
  }
  interval = Math.floor(seconds / 3600);
  if (interval > 1) {
    return interval + " hours";
  } else if (interval == 1) {
    return interval + " hour";
  }
  interval = Math.floor(seconds / 60);
  if (interval > 1) {
    return interval + " minutes";
  } else if (interval == 1) {
    return interval + " minute";
  }
  interval = Math.floor(seconds);
  if (interval > 1) {
    return interval + " seconds";
  } else {
    return "1 second";
  }
};

export const getLocalTimezoneOffset = () => {
  try {
    return moment().utcOffset() / 60;
  } catch (ex) {}
};

export const removeBootstarpMediaPrintSelector = () => {
  return new Promise(function (resolve) {
    if (document && document.styleSheets) {
      for (var i = 0; i < document.styleSheets.length; i++) {
        var sheet = document.styleSheets[i];
        if (sheet && sheet.title && sheet.title === "bootstrap") {
          if (typeof sheet.cssRules !== "undefined") {
            for (var j = 0; j < sheet.cssRules.length; j++) {
              var rule = sheet.cssRules[j];
              if (
                rule &&
                rule.conditionText &&
                rule.conditionText == "print" &&
                rule.cssText.includes("*, ::before, ::after")
              ) {
                sheet.deleteRule(j);
                j--;
              }
            }
          }
        }
      }
    }
    resolve();
  });
};

export const getDiscountString = (promoCode) => {
  if (promoCode?.discountType == DiscountTypes.PercentageDiscount) {
    return promoCode.discount + "%";
  }
  return promoCode.discount + "$";
};

export const printContent = (content, header, title, cssTitles = []) => {
  removeBootstarpMediaPrintSelector().then(function () {
    title = title ? title : "Print preview";
    var w = window.open("", "Print Preview", 'fullscreen="yes"');
    if (w) {
      w.document.write(
        '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">'
      );
      w.document.write("<html>");
      w.document.write("<head>");
      w.document.write("<title>" + title + "</title>");
      w.document.write("<meta charset='utf-8'>");

      var headChlidElements = $("head").find("link[title!=bootstrap]");
      var headElement = document.createElement("head");

      for (var i = 0; i < headChlidElements.length; i++) {
        $(headChlidElements[i]).clone().appendTo($(headElement));
      }

      w.document.write($(headElement).html());

      w.document.write("<style>");
      for (var i = 0; i < document.styleSheets.length; i++) {
        var sheet = document.styleSheets[i];
        if (
          sheet &&
          sheet.title &&
          (sheet.title === "bootstrap" || cssTitles.includes(sheet.title))
        ) {
          if (typeof sheet.cssRules !== "undefined") {
            for (var j = 0; j < sheet.cssRules.length; j++) {
              var rule = sheet.cssRules[j];
              if (rule && rule.cssText) {
                w.document.write(rule.cssText);
              }
            }
          }
        }
      }
      w.document.write("</style>");

      w.document.write("</head>");
      w.document.write("<body>");
      w.document.write('<div style="background: white;">');
      w.document.write(header);
      w.document.write(content);
      w.document.write("</div>");
      w.document.close();

      var is_chrome = Boolean(w.chrome);
      if (is_chrome) {
        w.onload = function () {
          // wait until all resources loaded
          w.focus(); // necessary for IE >= 10
          w.print();
        };
      } else {
        setTimeout(function () {
          w.focus(); // necessary for IE >= 10
          w.print(); // change window to mywindow
        }, 500);
      }
    }
  });
};

export const onImageError = (event) => {
  if (event && event.currentTarget) {
    event.currentTarget.src = No_Preview_available;

    const currentAlt = event.currentTarget.getAttribute("alt");
    if (
      !currentAlt?.trim() ||
      currentAlt === "Error" ||
      currentAlt === "File img"
    ) {
      event.currentTarget.alt = "Preview not available";
    }
  }
};

export const groupBy = function (field) {
  let groupedArr = [];
  this.forEach(function (e) {
    //look for an existent group
    let group = groupedArr.find((g) => g["field"] === e[field]);
    if (group == undefined) {
      //add new group if it doesn't exist
      group = { field: e[field], groupList: [] };
      groupedArr.push(group);
    }

    //add the element to the group
    group.groupList.push(e);
  });

  return groupedArr;
};

export const openUrlInNewTab = (url) => {
  if (url) {
    window.open(url, "_blank");
  }
};

export const createVideoCallUrl = (alias, params) => {
  if (alias) {
    var url = getApiUrl() + "/Conference?alias=" + alias;
    if (params) {
      url = url + "&" + $.param(params);
    }

    return url;
  }
};

export const redirectToCheckout = async (sessionId, stripeAccount) => {
  try {
    const { loadStripe } = await import("@stripe/stripe-js");
    const stripe = await loadStripe(getStripePublishableKey(), {
      stripeAccount
    });

    if (stripe) {
      await stripe.redirectToCheckout({ sessionId: sessionId });
    }
  } catch (ex) {
    console.error("Stripe redirect error:", ex);
  }
};

export const queryStringToJSON = () => {
  try {
    var pairs = window.location.search.slice(1).split("&");

    var result = {};
    pairs.forEach(function (pair) {
      if (pair != "") {
        pair = pair.split(/=(.*)/);
        result[pair[0].toLowerCase()] = decodeURIComponent(
          (pair[1] + "").replace(/\+/g, "%20")
        );
      }
    });

    return JSON.parse(JSON.stringify(result));
  } catch (ex) {}
};

export const queryStringToJSONWithoutDecode = () => {
  try {
    var pairs = window.location.search.slice(1).split("&");
    var result = {};
    pairs.forEach(function (pair) {
      pair = pair.split(/=(.*)/);
      result[pair[0].toLowerCase()] = pair[1] + "";
    });
    return JSON.parse(JSON.stringify(result));
  } catch (ex) {}
};

export const getDefaultPicPath = (element) => {
  if (element && element.src) {
    var source = element.src;
    var extension = source.split(".").pop();

    switch (extension) {
      case "ai":
      case "bmp":
      case "gif":
      case "ico":
      case "jpeg":
      case "jpg":
      case "png":
      case "ps":
      case "psd":
      case "svg":
      case "tif":
      case "tiff":
        return No_Preview_available;
      case "aif":
      case "cda":
      case "mid":
      case "midi":
      case "mp3":
      case "mpa":
      case "ogg":
      case "wav":
      case "wma":
      case "wpl":
        return audio_file_icon;
      case ".3g2":
      case "3gp":
      case "avi":
      case "flv":
      case "h264":
      case "m4v":
      case "mkv":
      case "mov":
      case "mp4":
      case "mpg":
      case "mpeg":
      case "rm":
      case "swf":
      case "vob":
      case "wmv":
        return video_file_icon;
      case "doc":
      case "docx":
      case "odt":
      case "rtf":
      case "tex":
      case "txt":
      case "wks":
      case "wps":
      case "wpd":
        return word_processor_file_icon;
      case "pdf":
        return pdf_file_icon;
      case "ods":
      case "xlr":
      case "xls":
      case "xlsx":
        return spreadsheet_file_icon;
      case "key":
      case "odp":
      case "pps":
      case "ppt":
      case "pptx":
      case ".csv":
        return presentation_file_icon;
      case "7z":
      case "arj":
      case "deb":
      case "pkg":
      case "rar":
      case "rpm":
      case "gz":
      case "z":
      case "zip":
        return compressed_file_icon;
      case "apk":
      case "bat":
      case "bin":
      case "cgi":
      case "pl":
      case "com":
      case "exe":
      case "gadget":
      case "jar":
      case "py":
      case "wsf":
        return executable_file_icon;
    }
  }

  return No_Preview_available;
};

function confirmDialogKeyPressHandler(event, action) {
  if (event && event.keyCode == KeyCodes.ENTER && action) {
    action();
  }
}

export const showAlertDialouge = (
  title,
  message,
  onConfirm,
  buttonText = "OK"
) => {
  let escapeClose = () => {};

  const options = {
    title: title ? title : "Message",
    message: message,
    childrenElement: () => <div />,
    customUI: ({ onClose }) => {
      var okBtnAction = function () {
        try {
          if (onConfirm) {
            onConfirm();
          }

          if (onClose) {
            onClose();
          }
        } catch (ex) {}
      };

      escapeClose = function () {
        try {
          if (onClose) {
            onClose();
          }
        } catch (ex) {}
      };

      return (
        <AlertDialogPanel
          title={title ? title : "Message"}
          titleId="alert-dialog-title"
          message={message}
          messageId="alert-dialog-message"
          onEscape={escapeClose}
        >
          <div className="react-confirm-alert-button-group">
            <button
              className="tab-focusable-background alert-dialog-ok-button"
              onKeyDown={(event) => {
                confirmDialogKeyPressHandler(event, okBtnAction);
              }}
              onClick={() => {
                okBtnAction();
              }}
            >
              {buttonText}
            </button>
          </div>
        </AlertDialogPanel>
      );
    },
    closeOnEscape: true,
    closeOnClickOutside: false,
    keyCodeForClose: [],
    willUnmount: () => {},
    afterClose: () => {},
    onClickOutside: () => {},
    onKeypressEscape: () => {
      escapeClose();
    },
    overlayClassName: "alert-dialog-overlay"
  };

  confirmAlert(options);
};

export const showConfirmDialouge = (title, message, onConfirm, onCancel) => {
  let escapeClose = () => {};

  const options = {
    title: title ? title : "Are you sure?",
    message: message,
    childrenElement: () => <div />,
    customUI: ({ onClose }) => {
      var yesBtnAction = function () {
        try {
          if (onConfirm) {
            onConfirm();
          }

          if (onClose) {
            onClose();
          }
        } catch (ex) {}
      };

      var noBtnAction = function () {
        try {
          if (onCancel) {
            onCancel();
          }

          if (onClose) {
            onClose();
          }
        } catch (ex) {}
      };

      escapeClose = noBtnAction;

      return (
        <AlertDialogPanel
          title={title ? title : "Are you sure?"}
          titleId="confirm-dialog-title"
          message={message}
          messageId="confirm-dialog-message"
          onEscape={escapeClose}
        >
          <div className="tab-focusable-background react-confirm-alert-button-group">
            <button
              id="yesbtn"
              className="alert-dialog-yes-button"
              onKeyDown={(event) => {
                confirmDialogKeyPressHandler(event, yesBtnAction);
              }}
              onClick={() => {
                yesBtnAction();
              }}
            >
              Yes
            </button>
            <button
              className="alert-dialog-no-button"
              onClick={() => {
                noBtnAction();
              }}
            >
              No
            </button>
            <button
              type="button"
              className="alert-dialog-close-button"
              aria-label="Close dialog"
              onClick={() => {
                noBtnAction();
              }}
            >
              Close
            </button>
          </div>
        </AlertDialogPanel>
      );
    },
    closeOnEscape: true,
    closeOnClickOutside: false,
    keyCodeForClose: [],
    willUnmount: () => {},
    afterClose: () => {},
    onClickOutside: () => {},
    onKeypressEscape: () => {
      escapeClose();
    },
    overlayClassName: "alert-dialog-overlay"
  };

  confirmAlert(options);
};

export const displayCopyToClipboardAlert = ({
  message,
  textToCopy,
  successMessage,
  errorMessage,
  successCallback,
  errorCallback
}) => {
  showAlertDialouge(
    "Message",
    message,
    function () {
      copyToClipboard(
        textToCopy,
        function () {
          showAlertDialouge("Message", successMessage, successCallback);
        },
        function () {
          showAlertDialouge("Error", errorMessage, errorCallback);
        }
      );
    },
    "Copy"
  );
};

export const handleBeforeUnload = (event) => {
  //Additional development required
  event.preventDefault();
  window.location.reload(false);
};

export const hasExceededMaxAllowedSize = (file, maxAllowedSizeMB) => {
  var hasExceededMaxSize = false;
  var maxAllowedFileSizeInMB = "";

  if (file) {
    var imageMaxSizeInBytes =
      (maxAllowedSizeMB
        ? maxAllowedSizeMB
        : MaxAllowdFileSizes.IMAGE_MAX_SIZE_IN_MB) *
      (1024 * 1024);
    var fileMaxSizeInBytes =
      (maxAllowedSizeMB
        ? maxAllowedSizeMB
        : MaxAllowdFileSizes.FILE_MAX_SIZE_IN_MB) *
      (1024 * 1024);
    var isImage = isImageFile(file.name);

    if (
      (isImage && file.size > imageMaxSizeInBytes) ||
      file.size > fileMaxSizeInBytes
    ) {
      hasExceededMaxSize = true;

      if (isImage) {
        maxAllowedFileSizeInMB = maxAllowedSizeMB
          ? maxAllowedSizeMB
          : MaxAllowdFileSizes.IMAGE_MAX_SIZE_IN_MB;
      } else {
        maxAllowedFileSizeInMB = maxAllowedSizeMB
          ? maxAllowedSizeMB
          : MaxAllowdFileSizes.FILE_MAX_SIZE_IN_MB;
      }
    }
  }

  return {
    hasExceededMaxSize: hasExceededMaxSize,
    maxAllowedFileSizeInMB: maxAllowedFileSizeInMB
  };
};

export const validateFileMaxSize = (files, maxAllowedFileSizeInMB) => {
  var errorMsg = "";
  if (files && Array.isArray(files) && files.length) {
    for (var i = 0; i < files.length; i++) {
      var returnObj = hasExceededMaxAllowedSize(
        files[i],
        maxAllowedFileSizeInMB
      );

      if (returnObj.hasExceededMaxSize) {
        errorMsg +=
          files[i].name +
          " has exceeded the maximum allowed size. Please upload less than " +
          returnObj.maxAllowedFileSizeInMB +
          " MB";
      }
    }
  }

  return errorMsg;
};

export const isFutureDate = (date) => {
  if (moment(date).diff(moment()) < 0) {
    return false;
  }
  return true;
};

export const isPastDate = (date) => {
  if (moment(date).diff(moment()) > 0) {
    return false;
  }
  return true;
};

export const isValidScheduledDate = (date) => {
  if (moment(date, "YYYY-MM-DD hh:mm A").diff(moment(), "minutes") >= 59) {
    return true;
  }
  return false;
};

export const isValidDate = (date) => {
  var dateTime = new Date(date);
  return !(!date || !dateTime.getTime());
};

export const isPatientDateOfBirthValid = (date) => {
  if (date) {
    var errorMessage = "";

    try {
      if (isValidDate(date)) {
        var isPatientFutureDate = isFutureDate(date);
        var currentYear = getCurrentDate("YYYY");
        var yearOfBirth = moment(date).format("YYYY");
        var patientMaxAge = 200;

        if (isPatientFutureDate) {
          errorMessage =
            "Patient date of birth is invalid. You cannot enter a future date.";
        } else if (currentYear - yearOfBirth > patientMaxAge)
          errorMessage =
            "Patient date of birth is invalid. Please enter a year within the past 200 years.";
      } else {
        errorMessage = "Please enter a valid date";
      }
    } catch (ex) {
      return {
        valid: false
      };
    }

    if (errorMessage) {
      return {
        valid: false,
        errorMessage
      };
    } else {
      return {
        valid: true
      };
    }
  } else {
    return {
      valid: false
    };
  }
};

export const getMinuteOptions = () => {
  var arr = [];

  for (var i = 0; i <= 59; i++) {
    arr.push(
      <option key={i} value={i}>
        {(i <= 9 ? "0" : "") + i}
      </option>
    );
  }

  return arr;
};

export const getHourOptions = () => {
  var arr = [];

  for (var i = 1; i <= 12; i++) {
    arr.push(
      <option key={i} value={i}>
        {(i <= 9 ? "0" : "") + i}
      </option>
    );
  }

  return arr;
};

export const getLocationName = (pathName) => {
  return "/" + pathName.split("/")[1];
};

export const PRINT_ROUTE_PREFIXES = [
  "/prescription-print",
  "/notes-print",
  "/form-print",
  "/visit-history-print",
  "/wellness-score-print"
];

export const isPrintRoute = (pathname) => {
  return PRINT_ROUTE_PREFIXES.includes(getLocationName(pathname));
};

export const shouldExcludeNavbar = (location) => {
  let pagesToExclude = [
    ...PRINT_ROUTE_PREFIXES,
    "/patient-record-request",
    "/cqismartscancici"
  ];
  let pathName = getLocationName(location.pathname);

  return pagesToExclude.includes(pathName);
};

export const shouldShowBrandLogoInPublicRoute = (pathname) => {
  let routes = [
    "/smart-scan-works-no-auth",
    "/smart-scan-disclaimer-no-auth",
    "/smart-scan-photo-options-no-auth",
    "/smart-scan-instruction-no-auth",
    "/smart-scan-lower-arch-no-auth",
    "/smart-scan-lower-arch-confirm-no-auth",
    "/smart-scan-lower-lip-no-auth",
    "/smart-scan-lower-lip-confirm-no-auth",
    "/smart-scan-upper-arch-no-auth",
    "/smart-scan-upper-arch-confirm-no-auth",
    "/smart-scan-upper-lip-no-auth",
    "/smart-scan-upper-lip-confirm-no-auth",
    "/smart-scan-bite-no-auth",
    "/smart-scan-bite-confirm-no-auth",
    "/smart-scan-pose-no-auth"
  ];

  return routes.includes(pathname);
};

export const isEmptyArray = (data) => {
  return !(data && Array.isArray(data) && data.length > 0);
};

export const GetDSTimezoneFullName = (offset) => {
  switch (offset) {
    case -4:
      return "Eastern Daylight Time";
    case -5:
      return "Central Daylight Time";
    case -6:
      return "Mountain Daylight Time";
    case -7:
      return "Pacific Daylight Time";
    case -8:
      return "Alaska Daylight Time";
    case -9:
      return "Hawaii-Aleutian Daylight Time";
    case 0:
      return "Greenwich Standard Time";
  }

  return "";
};

export const GetTimezoneFullName = (offset, isDST) => {
  if (isDST) {
    return GetDSTimezoneFullName(offset);
  }

  switch (offset) {
    case -5:
      return "Eastern Standard Time";
    case -6:
      return "Central Standard Time";
    case -7:
      return "Mountain Standard Time";
    case -8:
      return "Pacific Standard Time";
    case -9:
      return "Alaska Standard Time";
    case -10:
      return "Hawaiian Standard Time";
    case 0:
      return "Greenwich Standard Time";
  }
  return "";
};

export const convertKBFileSizeToMB = (fileSize) => {
  if (fileSize) {
    return fileSize / (1024 * 1024);
  }

  return 0;
};

export const isPDFfile = (source) => {
  if (source) {
    var extension = source.split(".").pop().toLowerCase();

    if (extension) {
      return extension === "pdf";
    }
  }
  return false;
};

export const getSubDomain = () => {
  if (window && window.location && window.location.hostname) {
    var currentPath = window.location.hostname;
    return currentPath.split(".")[0];
  }
};

export const getNameInitials = (patientName) => {
  if (patientName) {
    var patientNameInitialLetter = patientName
      .trim()
      .split(" ")
      .map((item) => {
        return item[0];
      });

    return (
      patientNameInitialLetter[0] + patientNameInitialLetter.pop()
    ).toUpperCase();
  }
};

export function validateDateOfBirth(
  dateOfBirth,
  excludeDependentPatientAgeLimitCheck = true
) {
  if (dateOfBirth) {
    const date = moment(dateOfBirth, "MM/DD/YYYY", true);

    if (date.isValid()) {
      const age = moment().diff(date, "years");

      if (age < 0) {
        return "Please enter a valid date. You cannot enter a future date.";
      }

      if (age < 18 && !excludeDependentPatientAgeLimitCheck) {
        return "A parent or legal guardian must create an account and add you as a dependent.";
      }

      if (age > 200) {
        return "Please enter a year within the past 200 years.";
      }

      return null;
    } else {
      return "Please enter a valid date.";
    }
  }
}

export function validateDate(date) {
  if (!isValidDate(date)) {
    return "Please enter a valid date";
  }
  return null;
}

export function validateScheduleAppointmentDate(date) {
  if (!isValidDate(date)) {
    return "Please enter a valid date";
  } else if (moment(date).diff(moment().format("MM-DD-YYYY")) < 0) {
    return "Please select a date from today or a future date.";
  }
  return null;
}

export function validatePhoneNumber(phoneNo) {
  if (phoneNo) {
    if (isPhoneNumberValid(phoneNo)) {
      return true;
    } else {
      return "Please enter a valid phone number.";
    }
  }
}

export function validatePassword(password) {
  if (isPasswordValid(password)) {
    return true;
  } else {
    return false;
  }
}

export function validateGroupNo(value) {
  if (value.length <= GroupNumMaxLength) {
    return true;
  } else {
    return (
      "The group number should not be more than " +
      GroupNumMaxLength +
      " characters"
    );
  }
}

export function getRegExpFromStrPattern(pattern) {
  return pattern ? new RegExp(pattern) : null;
}

export function validateSubscriberID(value, validator = {}) {
  let validatorRegex = getRegExpFromStrPattern(validator.validatorRegex);
  let validationMessage = validator.validationMessage
    ? validator.validationMessage
    : null;

  if (value && validatorRegex && validationMessage) {
    return validatorRegex.test(value) ? null : validationMessage;
  }

  return null;
}

export function getBrowserName() {
  let userAgent = navigator.userAgent;
  let browserName;

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "Chrome";
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "Firefox";
  } else if (userAgent.match(/safari/i)) {
    browserName = "Safari";
  } else if (userAgent.match(/opr\//i)) {
    browserName = "Opera";
  } else if (userAgent.match(/edg/i)) {
    browserName = "Edge";
  } else {
    browserName = "No browser detection";
  }

  return browserName;
}

export function getOS() {
  var userAgent = window.navigator.userAgent,
    platform =
      window.navigator?.userAgentData?.platform || window.navigator.platform,
    macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
    windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
    iosPlatforms = ["iPhone", "iPad", "iPod"],
    os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = "Mac OS";
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "iOS";
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "Windows";
  } else if (/Android/.test(userAgent)) {
    os = "Android";
  } else if (/Linux/.test(platform)) {
    os = "Linux";
  }

  return os;
}

export function checkBrowserVideoCallEligibility() {
  var os = getOS();
  var browser = getBrowserName();
  if (os == "iOS" && browser == "Chrome") {
    return {
      status: false,
      message:
        "Due to video and photo compatibility, iPhone users are required to use Safari for Dental.com. Please re-open Dental.com in Safari or copy the URL on this page and paste it into Safari."
    };
  }
  return {
    status: true
  };
}

export function auditConference(
  consultationId,
  eventName,
  pageName,
  patId = 0
) {
  let platformDetails = platform.description;

  let dataJSON = {
    pageName: pageName,
    EventName: eventName,
    browserString: platformDetails,
    consultationId: consultationId,
    siteName: getBaseUrl(),
    referer: document.referrer
      ? document.referrer
      : window.location?.href?.split("?")[0],
    patId: patId
  };

  auditConference_Ajax(JSON.stringify(dataJSON));
}

export function executeDentistDirectReferralProcess(
  linkType,
  encryptedProviderId,
  patId
) {
  return new Promise(function (resolve) {
    if (
      linkType == DentalDotComUrlParamLinkType.DentistDirectReferralUrl &&
      patId &&
      encryptedProviderId
    ) {
      const dataJSON = {
        encryptedProviderId: encryptedProviderId,
        patId: patId
      };
      addDentistDirectReferral_Ajax(
        JSON.stringify(dataJSON),
        function () {
          resolve();
        },
        function () {
          resolve();
        }
      );
    } else {
      resolve();
    }
  });
}

export function getMobileOperatingSystem() {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/android/i.test(userAgent)) {
    return MobileDevices.Android;
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return MobileDevices.iOS;
  }
  return MobileDevices.None;
}

export function isIosDevice(mobileDevice) {
  try {
    if (mobileDevice) {
      return mobileDevice == MobileDevices.iOS;
    } else {
      return getMobileOperatingSystem() == MobileDevices.iOS;
    }
  } catch (exception) {}
}

export function isAndroidDevice(mobileDevice) {
  try {
    if (mobileDevice) {
      return mobileDevice == MobileDevices.Android;
    } else {
      return getMobileOperatingSystem() == MobileDevices.Android;
    }
  } catch (exception) {}
}

export function getSmartScanImageCategoryName(category) {
  switch (category) {
    case smartScanCategory.Bite:
      return "Upper";
    case smartScanCategory.UpperArch:
      return "Right Side";
    case smartScanCategory.LowerArch:
      return "Left Side";
    case smartScanCategory.UpperLip:
      return "Front";
    case smartScanCategory.LowerLip:
      return "Lower";
    default:
      return "";
  }
}

export const getAccessibleImageAlt = (category) => {
  switch (category) {
    case smartScanCategory.UpperLip:
      return "Front view of teeth";

    case smartScanCategory.LowerArch:
      return "Left side of teeth";

    case smartScanCategory.UpperArch:
      return "Right side of teeth";

    case smartScanCategory.Bite:
      return "Upper teeth";

    case smartScanCategory.LowerLip:
      return "Lower teeth";

    default:
      return `${getSmartScanImageCategoryName(category)} image`;
  }
};

export function getTakePhotoAccessibleLabel(category) {
  switch (category) {
    case smartScanCategory.UpperLip:
      return "Take photo for front teeth";
    case smartScanCategory.LowerArch:
      return "Take photo for left side of teeth";
    case smartScanCategory.UpperArch:
      return "Take photo for right side of teeth";
    case smartScanCategory.LowerLip:
      return "Take photo for lower teeth";
    case smartScanCategory.Bite:
      return "Take photo for upper teeth";
    default:
      return `Take photo for ${getAccessibleImageAlt(category)}`;
  }
}

export const getRetakeLabel = (category) => {
  switch (category) {
    case smartScanCategory.UpperArch:
      return "Right Side Retake";

    case smartScanCategory.LowerArch:
      return "Left Side Retake";

    case smartScanCategory.UpperLip:
      return "Front Retake";

    case smartScanCategory.Bite:
      return "Upper Retake";

    case smartScanCategory.LowerLip:
      return "Lower Retake";

    default:
      return `${categoryName} Retake`;
  }
};

export function isSmartScanScorePerfect(score) {
  return score == SmartScanPerfectScore;
}

export function getSmartScanImageObjectNameForState(category) {
  switch (category) {
    case smartScanCategory.Bite:
      return "upper";
    case smartScanCategory.UpperArch:
      return "rightSide";
    case smartScanCategory.LowerArch:
      return "leftSide";
    case smartScanCategory.UpperLip:
      return "front";
    case smartScanCategory.LowerLip:
      return "lower";
    default:
      return "";
  }
}

export function getSmartScanStepNo(category) {
  switch (category) {
    case smartScanCategory.UpperArch:
      return 1;
    case smartScanCategory.LowerArch:
      return 2;
    case smartScanCategory.UpperLip:
      return 3;
    case smartScanCategory.LowerLip:
      return 4;
    case smartScanCategory.Bite:
      return 5;
    default:
      return 0;
  }
}

export function getCSSClassToStopScrollingInSmartScanPosePageInMobileDevice() {
  if (isAndroidDevice()) {
    return "android-device";
  } else if (isIosDevice()) {
    return "iphone-device";
  }
}

export function getSmartScanReportAccrodionColorClass(status) {
  if (status == SmartScanOralHealthStatus.Poor) {
    return "accordion-danger";
  } else if (status == SmartScanOralHealthStatus.Good) {
    return "accordion-success";
  } else if (status == SmartScanOralHealthStatus.NeedsImprovement) {
    return "accordion-gold";
  } else if (status == SmartScanOralHealthStatus.NonObservable) {
    return "accordion-non-observable";
  }

  return "";
}

export function validateImage(file, maxAllowedSizeInMB = 0) {
  let errMsg = "";

  if (maxAllowedSizeInMB == 0) {
    maxAllowedSizeInMB = MaxAllowdFileSizes.IMAGE_MAX_SIZE_IN_MB_5;
  }

  if (file && maxAllowedSizeInMB > 0) {
    let fileName = file.name.toLowerCase();
    let isImageTypeFile = isImageFile(fileName);
    let fileSizeErrMsg = validateFileMaxSize([file], maxAllowedSizeInMB);

    if (!isImageTypeFile) {
      errMsg = "File type not supported";
    } else if (fileSizeErrMsg) {
      errMsg = fileSizeErrMsg;
    }
  }

  return errMsg;
}

export function handleEnterKeyPress(event) {
  if (event.key === "Enter") {
    event.target.click();
  }
}

export async function getCompressedFile(file) {
  try {
    if (file) {
      let fileName = file.name;
      let compressedFile = await compressFile(
        file,
        FileCompressQuality.Image_Quality
      );
      if (compressedFile) {
        return new File([compressedFile], fileName, {
          type: compressedFile.type
        });
      }
    }
  } catch (ex) {
    console.error("Compression failed:", ex);
  }

  return undefined;
}

async function compressFile(image, quality) {
  const { default: Compressor } = await import("compressorjs");

  return new Promise((resolve, reject) => {
    new Compressor(image, {
      quality,
      success: (res) => resolve(res),
      error: (err) => reject(err)
    });
  });
}

export function getCampaignStatesOfType(type, states) {
  let filteredStates = [];
  states.forEach((state) => {
    if (state.type === type) {
      filteredStates.push(state);
    }
  });
  return filteredStates;
}

export function getSeeADentistNowButtonText() {
  return "See a Dentist Now";
}

export function shouldSelectCurrentPatientByDefault(
  patientAndFamilyMemberList
) {
  return (
    getPatientInfo() &&
    patientAndFamilyMemberList &&
    Array.isArray(patientAndFamilyMemberList) &&
    patientAndFamilyMemberList.length == 1
  );
}

export function getDefaultSelectedPatientId(patientAndFamilyMemberList) {
  if (shouldSelectCurrentPatientByDefault(patientAndFamilyMemberList)) {
    return getPatientInfo().patid;
  }
  return 0;
}

export function getGenderText(gender) {
  if (!gender) return "";

  switch (gender) {
    case GenderOptions.Male:
      return "Male";
    case GenderOptions.Female:
      return "Female";
    case GenderOptions.Unknown:
      return "Other";
    case GenderOptions.Other:
      return "Other";
    default:
      return "";
  }
}

export const ConvertFileToBase64String = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

export function arrayBufferToBlob(buffer, fileName, mimeType) {
  let blob = new Blob([buffer], { type: mimeType });
  return new File([blob], fileName);
}

export function fileToArrayBuffer(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
  });
}

export const formatCurrency = (currency) => {
  if (currency) {
    return "$" + currency;
  }

  return "";
};

export const formatVersion = (version) => {
  if (version) {
    return "v" + version;
  }

  return "v1";
};

export const isCampaignShareStateAvailable = (data) => {
  if (data) {
    let sharedStates = getCampaignStatesOfType(
      CampaignStateSettingTypes.Shared,
      data.campaignStates
    );
    if (!isEmptyArray(sharedStates) && data.isRecordShareConsentEnabled) {
      return sharedStates;
    }
  }
};

const getFormIoComponentLabel = (component) => {
  if (!component) return null;

  return (
    component.querySelector("label.field-required, label.control-label, label") ||
    component.closest(".formio-component-panel")?.querySelector(".card-title") ||
    component.querySelector(".card-title")
  );
};

const ensureElementId = (element, prefix = "formio-label") => {
  if (!element) return null;

  if (!element.id) {
    element.id = `${prefix}-${Math.random().toString(36).slice(2, 10)}`;
  }

  return element.id;
};

export const syncFormIoSignatureValue = (value) => {
  const hiddenInput = document.querySelector('[name="data[signature]"]');
  const preview = document.getElementById("signaturePreview");

  if (hiddenInput) {
    hiddenInput.value = value;
    hiddenInput.dispatchEvent(new Event("input", { bubbles: true }));
    hiddenInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  if (preview) {
    preview.value = value;
    preview.dispatchEvent(new Event("input", { bubbles: true }));
    preview.dispatchEvent(new Event("change", { bubbles: true }));
  }
};

const FORM_PRINT_CONTROL_SELECTOR =
  "input, select, textarea, [role='combobox'], [role='slider'], [role='spinbutton']";

export const fixFormIoComplexLabelAssociations = () => {
  document.querySelectorAll(".formio-component").forEach((component) => {
    const label = component.querySelector("label[for]");
    if (!label) {
      return;
    }

    const forId = label.getAttribute("for");
    const target = forId ? document.getElementById(forId) : null;

    if (target) {
      return;
    }

    const control = component.querySelector(FORM_PRINT_CONTROL_SELECTOR);
    const group = component.querySelector('[role="group"], [role="radiogroup"]');
    const checkboxes = component.querySelectorAll('input[type="checkbox"]');
    const firstCheckbox = checkboxes[0];

    if (control) {
      if (!control.id) {
        control.id =
          control.getAttribute("name") ||
          control.getAttribute("id") ||
          `formio-${Math.random().toString(36).slice(2, 10)}`;
      }

      label.setAttribute("for", control.id);
      return;
    }

    if (firstCheckbox) {
      if (!firstCheckbox.id) {
        firstCheckbox.id =
          firstCheckbox.getAttribute("name") ||
          `formio-${Math.random().toString(36).slice(2, 10)}`;
      }

      label.removeAttribute("for");
      ensureElementId(label, "group-label");

      const groupEl =
        group ||
        firstCheckbox.closest('[role="group"], .form-radio, .form-radio.radio');

      if (groupEl) {
        groupEl.setAttribute("aria-labelledby", label.id);
      }

      return;
    }

    label.removeAttribute("for");

    if (!label.id) {
      label.id = `formio-label-${Math.random().toString(36).slice(2, 10)}`;
    }

    if (group) {
      group.setAttribute("aria-labelledby", label.id);
    }
  });
};

export const fixFormIoSignatureImages = () => {
  document
    .querySelectorAll(
      "#campaign-form img, .form-section img, .formio-component-signature img, img[src^='data:image']"
    )
    .forEach((img) => {
      if (!img.getAttribute("alt")?.trim()) {
        img.setAttribute("alt", "Patient signature");
      }
    });
};

export const fixFormIoChoicesListboxOptions = () => {
  document.querySelectorAll(".formio-component select[name^='data[']").forEach((select) => {
    const component = select.closest(".formio-component");
    const listbox = component?.querySelector(
      ".choices__list[role='listbox'], .choices__list--dropdown[role='listbox'], .choices__list--dropdown"
    );

    if (!listbox || !select.options?.length) {
      return;
    }

    ensureElementId(listbox, "formio-listbox");

    let srContainer = listbox.querySelector(".formio-a11y-options");

    if (!srContainer) {
      srContainer = document.createElement("div");
      srContainer.className = "formio-a11y-options visually-hidden";
      listbox.appendChild(srContainer);
    }

    srContainer.innerHTML = "";

    Array.from(select.options).forEach((option, index) => {
      const optionEl = document.createElement("div");
      optionEl.setAttribute("role", "option");
      optionEl.id = `${listbox.id}-option-${index}`;
      optionEl.textContent = option.textContent?.trim() || option.value;
      srContainer.appendChild(optionEl);
    });
  });
};

export const fixFormIoDatetimeAccessibility = () => {
  document.querySelectorAll(".formio-component-datetime").forEach((component) => {
    const input = component.querySelector("input");
    if (!input) {
      return;
    }

    const label = getFormIoComponentLabel(component);

    if (label) {
      ensureElementId(label, "datetime-label");

      if (!input.getAttribute("aria-labelledby")) {
        input.setAttribute("aria-labelledby", label.id);
      }
    }

    let hint = component.querySelector(".datetime-format-hint");

    if (!hint) {
      hint = document.createElement("span");
      hint.className = "datetime-format-hint visually-hidden";
      hint.id = `datetime-hint-${Math.random().toString(36).slice(2, 8)}`;
      hint.textContent =
        "Press Enter or Space to open the calendar. Use arrow keys to move between dates, Page Up and Page Down to change months, and Escape to close the calendar.";
      component.appendChild(hint);
    }

    const describedBy = [input.getAttribute("aria-describedby"), hint.id]
      .filter(Boolean)
      .join(" ");

    if (describedBy) {
      input.setAttribute("aria-describedby", describedBy);
    }

    if (!input.dataset.a11yDatetimeFixed) {
      input.dataset.a11yDatetimeFixed = "true";

      input.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          const calendar = document.querySelector(".flatpickr-calendar.open");

          if (calendar) {
            event.preventDefault();
            calendar.classList.remove("open");
            input.focus();
          }
        }
      });
    }
  });

  document.querySelectorAll(".flatpickr-calendar").forEach((calendar) => {
    if (calendar.dataset.a11yCalendarFixed) {
      return;
    }

    calendar.dataset.a11yCalendarFixed = "true";
    calendar.setAttribute("role", "dialog");
    calendar.setAttribute("aria-label", "Choose date");

    calendar
      .querySelectorAll(
        ".flatpickr-day, .flatpickr-monthDropdown-months, .flatpickr-monthDropdown-years, .flatpickr-prev-month, .flatpickr-next-month, .flatpickr-current-month"
      )
      .forEach((element) => {
        if (!element.getAttribute("tabindex")) {
          element.setAttribute("tabindex", "0");
        }
      });
  });
};

export const fixAllFormIoAccessibilityIssues = () => {
  document
    .querySelectorAll('input[type="checkbox"][role="checkbox"]')
    .forEach((checkbox) => {
      checkbox.removeAttribute("role");
    });

  document.querySelectorAll(".formio-component").forEach((component) => {
    const label = component.querySelector("label");
    const input = component.querySelector(
      "input, select, textarea, [role='combobox']"
    );

    if (label && input) {
      if (!input.id) {
        input.id =
          input.getAttribute("name") ||
          `formio-${Math.random().toString(36).slice(2, 10)}`;
      }

      label.setAttribute("for", input.id);
    }
  });

  document
    .querySelectorAll(
      "[aria-required='true'], [aria-required=''], [aria-required]"
    )
    .forEach((el) => {
      const tag = el.tagName?.toLowerCase();
      const role = el.getAttribute("role");

      if (
        !["input", "textarea", "select"].includes(tag) ||
        role === "group" ||
        role === "radiogroup"
      ) {
        el.removeAttribute("aria-required");
      }
    });

  document
    .querySelectorAll(
      '[role="group"][aria-required], [role="radiogroup"][aria-required], .form-radio[aria-required]'
    )
    .forEach((el) => {
      el.removeAttribute("aria-required");
    });

  document.querySelectorAll(".choices__button").forEach((btn) => {
    btn.remove();
  });

  document.querySelectorAll(".formio-component").forEach((component) => {
    const checkboxes = component.querySelectorAll('input[type="checkbox"]');
    const radios = component.querySelectorAll('input[type="radio"]');
    const group = checkboxes[0]?.closest('[role="group"], .form-radio, .form-radio.radio')
      || radios[0]?.closest('[role="group"], .form-radio, .form-radio.radio');

    if (!group) return;

    const label = getFormIoComponentLabel(component);

    if (label) {
      ensureElementId(label, "group-label");
      group.setAttribute("aria-labelledby", label.id);
    }

    if (checkboxes.length > 0) {
      group.setAttribute("role", "group");

      const isRequired =
        component.classList.contains("formio-component-required") ||
        component.querySelector(".field-required");

      if (isRequired) {
        checkboxes.forEach((checkbox) => {
          checkbox.setAttribute("aria-required", "true");
        });
      }
    } else if (radios.length > 0) {
      group.setAttribute("role", "radiogroup");
    }
  });

  fixFormIoComplexLabelAssociations();
};

export const fixFormIoPainLevelAccessibility = () => {
  document.querySelectorAll('select[name="data[painLevel]"]').forEach((select) => {
    const component = select.closest(".formio-component");
    if (!component) return;

    const panel =
      component.closest(".formio-component-panel") ||
      component.parentElement?.closest(".formio-component-panel");

    const emergencyNotice =
      panel?.querySelector(".formio-component-htmlelement p") ||
      component.parentElement?.querySelector(".formio-component-htmlelement p");

    if (emergencyNotice) {
      ensureElementId(emergencyNotice, "pain-level-emergency-notice");
    }

    const cardTitle =
      panel?.querySelector(".card-title") || getFormIoComponentLabel(component);

    if (cardTitle) {
      ensureElementId(cardTitle, "pain-level-label");
    }

    const describedByIds = [emergencyNotice?.id].filter(Boolean).join(" ");
    const controls = [
      component.querySelector(
        ".form-control.ui.fluid.selection.dropdown[tabindex='0']"
      ),
      component.querySelector(".formio-choices"),
      component.querySelector(".formio-select-autocomplete-input"),
      component.querySelector("[tabindex='0'].form-control")
    ].filter(Boolean);

    controls.forEach((control) => {
      if (cardTitle?.id) {
        control.setAttribute("aria-labelledby", cardTitle.id);
      }

      if (describedByIds) {
        control.setAttribute("aria-describedby", describedByIds);
      }

      control.removeAttribute("aria-label");
    });
  });
};

export const fixFormIoChoicesAccessibility = () => {
  document.querySelectorAll(".formio-component").forEach((component) => {
    const hasChoices =
      component.querySelector("select[name^='data[']") ||
      component.querySelector(".formio-choices");

    if (!hasChoices) return;

    const label = getFormIoComponentLabel(component);
    if (!label) return;

    ensureElementId(label, "formio-label");

    const listbox = component.querySelector(
      ".choices__list[role='listbox'], .choices__list--dropdown[role='listbox'], .choices__list--dropdown"
    );

    if (listbox) {
      ensureElementId(listbox, "formio-listbox");
    }

    const controls = [
      component.querySelector(".formio-choices"),
      component.querySelector(
        ".form-control.ui.fluid.selection.dropdown[tabindex='0']"
      ),
      component.querySelector(".formio-select-autocomplete-input"),
      component.querySelector("[role='combobox']"),
      component.querySelector("[tabindex='0'].form-control")
    ].filter(Boolean);

    controls.forEach((control) => {
      control.setAttribute("aria-labelledby", label.id);
      control.removeAttribute("aria-label");

      if (listbox?.id) {
        control.setAttribute("aria-controls", listbox.id);
      }
    });
  });

  fixFormIoPainLevelAccessibility();
  fixFormIoChoicesListboxOptions();
};

export const fixFormIoSignatureAccessibility = () => {
  document.querySelectorAll(".formio-component-signature").forEach((component) => {
    if (component.dataset.a11ySignatureFixed) return;

    component.dataset.a11ySignatureFixed = "true";

    component.querySelectorAll("a[href]").forEach((link) => {
      if (link.dataset.a11yLinkFixed) return;

      link.dataset.a11yLinkFixed = "true";
      link.setAttribute("role", "button");
      link.setAttribute("aria-label", "Open signature pad");

      if (!link.getAttribute("tabindex")) {
        link.setAttribute("tabindex", "0");
      }

      link.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          link.click();
        }
      });
    });

    let hint = component.querySelector(".signature-draw-hint");

    if (!hint) {
      hint = document.createElement("div");
      hint.className = "signature-draw-hint visually-hidden";
      hint.id = `signature-draw-hint-${Math.random().toString(36).slice(2, 8)}`;
      hint.textContent =
        "Use mouse or touch to draw your signature, or use the type or upload alternative below.";
      component.appendChild(hint);
    }

    component.querySelectorAll(".signature-pad-body canvas").forEach((canvas) => {
      canvas.setAttribute("aria-describedby", hint.id);
    });

    if (component.querySelector(".signature-alternatives-a11y")) return;

    const region = document.createElement("div");
    region.className = "signature-alternatives-a11y mt-3";
    region.setAttribute("role", "region");
    region.setAttribute("aria-label", "Signature alternatives");

    const componentKey =
      component.getAttribute("ref") ||
      component.dataset.key ||
      Math.random().toString(36).slice(2, 8);

    const typeInputId = `typed-signature-${componentKey}`;
    const uploadInputId = `upload-signature-${componentKey}`;

    const typeLabel = document.createElement("label");
    typeLabel.className = "form-label";
    typeLabel.setAttribute("for", typeInputId);
    typeLabel.textContent = "Type your full name as signature";

    const typeInput = document.createElement("input");
    typeInput.type = "text";
    typeInput.id = typeInputId;
    typeInput.className = "form-control wcag-contrast-border-color mt-1 mb-2";
    typeInput.setAttribute("aria-label", "Type your full name as signature");
    typeInput.addEventListener("input", () => {
      syncFormIoSignatureValue(typeInput.value);
    });

    const uploadLabel = document.createElement("label");
    uploadLabel.className = "form-label mt-2";
    uploadLabel.setAttribute("for", uploadInputId);
    uploadLabel.textContent = "Upload signature image";

    const uploadInput = document.createElement("input");
    uploadInput.type = "file";
    uploadInput.id = uploadInputId;
    uploadInput.accept = "image/*";
    uploadInput.className = "form-control mt-1";
    uploadInput.setAttribute("aria-label", "Upload signature image");
    uploadInput.addEventListener("change", () => {
      const file = uploadInput.files?.[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = () => {
        syncFormIoSignatureValue(reader.result);
      };
      reader.readAsDataURL(file);
    });

    region.appendChild(typeLabel);
    region.appendChild(typeInput);
    region.appendChild(uploadLabel);
    region.appendChild(uploadInput);
    component.appendChild(region);
  });
};

const FORM_PRINT_INSTRUCTION_HEADING_TEXT =
  "Please fill out the questions below and select 'Submit' to continue.";

const fixFormIoPanelAriaForPrint = () => {
  document
    .querySelectorAll("#form-body .card-header[role='presentation']")
    .forEach((el) => {
      el.removeAttribute("aria-expanded");
      el.removeAttribute("aria-controls");
    });
};

const fixFormIoComplexLabelAssociationsForPrint = () => {
  document.querySelectorAll("#form-body .formio-component").forEach((component) => {
    const label = component.querySelector("label[for]");
    if (!label) {
      return;
    }

    const forId = label.getAttribute("for");
    const target = forId ? document.getElementById(forId) : null;

    if (target) {
      return;
    }

    const control = component.querySelector(FORM_PRINT_CONTROL_SELECTOR);
    const group = component.querySelector('[role="group"], [role="radiogroup"]');

    if (control) {
      if (!control.id) {
        control.id =
          control.getAttribute("name") ||
          control.getAttribute("id") ||
          `formio-${Math.random().toString(36).slice(2, 10)}`;
      }

      label.setAttribute("for", control.id);
      return;
    }

    label.removeAttribute("for");

    if (!label.id) {
      label.id = `form-print-label-${Math.random().toString(36).slice(2, 10)}`;
    }

    if (group) {
      group.setAttribute("aria-labelledby", label.id);
    }
  });
};

const fixFormIoSignatureImagesForPrint = () => {
  document.querySelectorAll("#form-body img").forEach((img) => {
    if (!img.getAttribute("alt")?.trim()) {
      img.setAttribute("alt", "Patient signature");
    }
  });
};

const fixFormIoInstructionHeadingsForPrint = () => {
  document
    .querySelectorAll("#form-body .formio-component-content")
    .forEach((contentComponent) => {
      if (contentComponent.querySelector("h1, h2, h3, h4, h5, h6")) {
        return;
      }

      const textContent = contentComponent.textContent?.trim();
      if (!textContent) {
        return;
      }

      const isInstructionHeading =
        textContent === FORM_PRINT_INSTRUCTION_HEADING_TEXT ||
        /please fill out the questions below/i.test(textContent);

      if (!isInstructionHeading) {
        return;
      }

      const heading = document.createElement("h2");
      heading.className = "form-print-section-heading";
      heading.textContent = textContent;

      contentComponent.innerHTML = "";
      contentComponent.appendChild(heading);
    });
};

export const fixFormIoAccessibilityIssuesForPrint = () => {
  fixAllFormIoAccessibilityIssues();
  fixFormIoPanelAriaForPrint();
  fixFormIoComplexLabelAssociationsForPrint();
  fixFormIoSignatureImagesForPrint();
  fixFormIoInstructionHeadingsForPrint();
};

export const initializeFormIoAccessibilityForPrint = () => {
  fixFormIoAccessibilityIssuesForPrint();
};

export const fixFormIoLabelForMismatch = () => {
  const components = document.querySelectorAll(".formio-component");

  components.forEach((component) => {
    const label = component.querySelector("label");

    const input = component.querySelector(
      "input, select, textarea, [role='combobox']"
    );

    if (!label || !input) return;

    if (!input.id) {
      const generatedId =
        input.getAttribute("name") ||
        `formio-${Math.random().toString(36).slice(2, 10)}`;

      input.id = generatedId;
    }

    label.setAttribute("for", input.id);
  });
};

export const fixChoicesNestedButtonIssue = () => {
  document.querySelectorAll(".choices__item--selectable").forEach((item) => {
    const removeBtn = item.querySelector(".choices__button");

    if (removeBtn) {
      const value = item.getAttribute("data-value");

      removeBtn.remove();

      item.setAttribute("tabindex", "0");

      item.addEventListener("keydown", (e) => {
        if (e.key === "Delete" || e.key === "Backspace") {
          const select = item
            .closest(".formio-component")
            ?.querySelector("select");

          if (select) {
            const option = select.querySelector(`option[value="${value}"]`);
            if (option) option.selected = false;

            select.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }
      });
    }
  });
};

export const initializeFormIoAccessibilityOnRender = ({
  includeSubmitButtonChanges = true
} = {}) => {
  fixAllFormIoAccessibilityIssues();
  fixFormIoChoicesAccessibility();
  fixFormIoDatetimeAccessibility();
  fixFormIoSignatureImages();
  addEventListenerInFormIo();

  if (includeSubmitButtonChanges) {
    changeSubmitButtonTextAndStyle();
    fixChoicesNestedButtonIssue();
  }
};

export const initializeFormIoAccessibilityOnReadOnlyRender = () => {
  initializeFormIoAccessibilityOnRender({ includeSubmitButtonChanges: false });
};

export const initializeAdditionalChangesInFormIoFormDuringRender = () => {
  initializeFormIoAccessibilityOnRender({ includeSubmitButtonChanges: true });
};

export const changeSubmitButtonTextAndStyle = () => {
  let submitButtonDiv = document.querySelectorAll(
    ".formio-component-submit"
  )[0];

  if (submitButtonDiv) {
    submitButtonDiv?.classList?.add("text-center");
  }

  let submitButton = document.querySelectorAll(
    ".formio-component-submit button"
  )[0];

  if (submitButton) {
    submitButton.innerHTML = "Submit and Next";
    submitButton?.classList?.add("btn-secondary");
    submitButton?.classList?.add("tab-focusable-background");
  }
};

export const initializeAdditionalChangesInFormIoFormDuringCreate = (
  elementId,
  formData
) => {
  setCustomValueInFormIoFields(elementId, formData);
};

export const setCustomValueInFormIoFields = (elementId, formData) => {
  if (!elementId || !formData) {
    return;
  }

  if (
    formData?.signature &&
    document.querySelectorAll("#" + elementId + " #signaturePreview")[0]
  ) {
    let element = "#" + elementId + " #signaturePreview";
    $(element).val(formData?.signature);
  }

  const signatureImg = document.querySelector('img[src^="data:image/png;base64"]');
  
  if (signatureImg) {
    signatureImg.setAttribute("alt", "Form signature");
  }
};

export const fixSignaturePadBodyAccessibility = () => {
  document.querySelectorAll(".signature-pad-body").forEach((el) => {
    el.setAttribute("tabindex", "-1");

    el.removeAttribute("role");
  });

  document.querySelectorAll(".signature-pad-body canvas").forEach((canvas) => {
    canvas.setAttribute("role", "application");
    canvas.setAttribute("aria-label", "Signature drawing area");
    canvas.setAttribute("tabindex", "0");
  });
};
export const fixSignatureResetButtonAccessibility = () => {
  const applyFix = () => {
    document.querySelectorAll(".signature-pad-refresh").forEach((btn) => {
      if (btn.dataset.a11yFixed) return;

      btn.dataset.a11yFixed = "true";
      btn.setAttribute("tabindex", "0");
      btn.setAttribute("role", "button");
      btn.setAttribute("aria-label", "Reset signature");

      btn.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          btn.click();
        }
      });
    });
  };

  applyFix();

  const observer = new MutationObserver(() => {
    applyFix();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};

export const addEventListenerInFormIo = () => {
  let signaturePreviewDiv = document.querySelectorAll("#signaturePreview")[0];
  signaturePreviewDiv?.setAttribute("aria-label", "Signature preview");
  let signatureDiv = document.querySelectorAll(".eTypeSignatureFormIo")[0];
  let selectOptions = document.querySelectorAll(".choices__list");

  document.querySelectorAll("[aria-required='true']").forEach((el) => {
    const tag = el.tagName?.toLowerCase();

    if (!["input", "textarea", "select"].includes(tag)) {
      el.removeAttribute("aria-required");
    }
  });

  selectOptions?.forEach((listDiv) => {
    listDiv.classList.add("notranslate");
  });

  const checkboxes = document.querySelectorAll(
    '#campaign-form input[type="checkbox"]'
  );
  checkboxes?.forEach((checkbox) => {
    checkbox.addEventListener("keydown", handleEnterKeyPress);
  });

  fixSignaturePadBodyAccessibility();
  fixSignatureResetButtonAccessibility();
  fixFormIoSignatureAccessibility();
  if (signatureDiv && signaturePreviewDiv) {
    document
      .getElementsByClassName("eTypeSignatureFormIo")[0]
      .addEventListener("keyup", setValueOfPreviewSignature, true);
  }
};

export const setValueOfPreviewSignature = () => {
  if (
    document.getElementById("signaturePreview") &&
    document.getElementsByName("data[signature]")
  ) {
    document.getElementById("signaturePreview").value =
      document.getElementsByName("data[signature]")[0].value;
  }
};

export const getCarrierIdFromInsurance = (insuranceInfo, insuranceCarrier) => {
  if (!insuranceCarrier.length) {
    return 0;
  }
  const carrier = insuranceCarrier?.find(
    (item) =>
      item.name === insuranceInfo?.carrierName &&
      item.code === insuranceInfo?.carrierCode
  );
  return carrier?.id;
};

export const checkForPaymentCompletionStatus = (paymentsuccess) => {
  let title = getPaymentCompletionDialougeTitle(paymentsuccess);
  let message = getPaymentCompletionMessage(paymentsuccess);

  if (title && message) {
    showAlertDialouge(title, message);
  }
};

export const getPaymentCompletionMessage = (status) => {
  if (status == "true") return "Payment has been completed successfully.";
  else if (status == "false") return "Failed to complete the payment.";
  else return "";
};

export const getPaymentCompletionDialougeTitle = (status) => {
  if (status == "true") return "Message";
  else if (status == "false") return "Error";
  else return "";
};

export const copyToClipboard = (textToCopy, successCallback, errorCallback) => {
  if (navigator?.clipboard?.writeText && textToCopy) {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        if (successCallback) {
          successCallback();
        }
      })
      .catch(() => {
        if (errorCallback) {
          errorCallback();
        }
      });
  }
};

export const isReferralNotificationType = (type) => {
  return ReferralsNotificationTypesRedirectURL?.some(
    ([notificationType]) => notificationType === type
  );
};

export const isFeatureNotificationDisabledForOrigin = (type) => {
  return (
    !isReferralFeatureEnabledForOrigin() && isReferralNotificationType(type)
  );
};

export const extractCustomLinkQueryParams = () => {
  let paramsWithoutDecode = queryStringToJSONWithoutDecode();

  if (paramsWithoutDecode.linktype && paramsWithoutDecode.data) {
    return {
      linkType: paramsWithoutDecode.linktype,
      version: 0,
      dataString: paramsWithoutDecode.data
    };
  } else if (paramsWithoutDecode.v && paramsWithoutDecode.data) {
    return {
      version: parseInt(paramsWithoutDecode.v),
      dataString: paramsWithoutDecode.data
    };
  }

  return {
    linkType: 0,
    version: 0,
    dataString: null
  };
};

export const getSmartScanQuadrantTypeName = (quadrantNumber) => {
  switch (quadrantNumber) {
    case SmartScanQuadrantType.UpperLeft:
      return "UL";
    case SmartScanQuadrantType.UpperRight:
      return "UR";
    case SmartScanQuadrantType.LowerLeft:
      return "LL";
    case SmartScanQuadrantType.LowerRight:
      return "LR";
  }

  return "";
};

export const getAddressFromGooglePlaceObject = (place) => {
  if (!place.address_components) {
    return null;
  }

  let address = {
    fullAddress: "",
    country: "",
    state: "",
    city: "",
    zip: ""
  };

  address.fullAddress = place.formatted_address;

  for (const component of place.address_components) {
    const componentType = component.types[0];

    switch (componentType) {
      case "postal_code": {
        address.zip = component.long_name;
        break;
      }
      case "administrative_area_level_1": {
        address.state = component.short_name;
        break;
      }

      case "sublocality_level_1":
      case "locality": {
        address.city = component.long_name;
        break;
      }

      case "country":
        address.country = component.short_name;
        break;
    }
  }

  return address;
};

export const getCurrentLocationDetails = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported by this browser."));
      return;
    }

    if (!window.google || !window.google.maps) {
      reject(new Error("Google Maps is not loaded yet."));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        try {
          const { latitude, longitude, accuracy, altitude, heading, speed } =
            position.coords;
          const geocoder = new window.google.maps.Geocoder();
          const latlng = { lat: latitude, lng: longitude };

          geocoder.geocode({ location: latlng }, (results, status) => {
            if (
              status === "OK" &&
              results &&
              results.length > 0 &&
              results[0].formatted_address
            ) {
              const formattedAddress = results[0].formatted_address;
              const place = getAddressFromGooglePlaceObject(results[0]);
              place.fullAddress = formattedAddress;

              const components = results[0].address_components;

              const zipCode =
                components.find((comp) => comp.types.includes("postal_code"))
                  ?.long_name ||
                components.find((comp) =>
                  comp.types.includes("administrative_area_level_2")
                )?.long_name ||
                null;

              const city =
                components.find((comp) => comp.types.includes("locality"))
                  ?.long_name ||
                components.find((comp) =>
                  comp.types.includes("administrative_area_level_2")
                )?.long_name ||
                null;

              const state =
                components.find((comp) =>
                  comp.types.includes("administrative_area_level_1")
                )?.long_name || null;

              const country =
                components.find((comp) => comp.types.includes("country"))
                  ?.long_name || null;

              resolve({
                latitude,
                longitude,
                accuracy,
                altitude,
                heading,
                speed,
                place,
                formattedAddress,
                zipCode,
                city,
                state,
                country
              });
            } else {
              reject(new Error("Geocoder returned incomplete result."));
            }
          });
        } catch (err) {
          reject(err);
        }
      },
      (error) => {
        const messages = {
          1: "Location access denied. Please enable location permissions in your browser settings.",
          2: "Unable to determine your location. Please check your connection and try again.",
          3: "Location request timed out. Please try again."
        };
        reject(
          new Error(messages[error.code] || "Unable to retrieve location.")
        );
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 30000 }
    );
  });
};

export const captureNativeSelectValueOnFocus = (getValue, fieldName) => (event) => {
  event.currentTarget.dataset.previousValue = getValue(fieldName) ?? "";
};

export const createNativeSelectEscapeHandler =
  ({ getValue, setValue, fieldName }) =>
  (event) => {
    const el = event.currentTarget;

    if (event.key === "Escape") {
      event.preventDefault();
      event.stopPropagation();
      const previousValue = el.dataset.previousValue ?? getValue(fieldName) ?? "";
      setValue(fieldName, previousValue, {
        shouldValidate: true,
        shouldDirty: true
      });
      el.blur();
      return;
    }

    const openKeys = [
      "ArrowDown",
      "ArrowUp",
      "Home",
      "End",
      "Enter",
      " "
    ];

    if (openKeys.includes(event.key)) {
      el.dataset.previousValue = getValue(fieldName) ?? "";
    }
  };

export function handleRemoveProfilePhoto(confirmCallback) {
  return function (event) {
    event.preventDefault();
    showConfirmDialouge(
      "Are you sure?",
      "You are about to remove your profile photo.",
      confirmCallback
    );
  };
}

export const getUtmParams = () => {
  const referrerUrl = document.referrer || "";

  if (referrerUrl) {
    const url = new URL(referrerUrl);
    const queryParams = new URLSearchParams(url.search);
    const utmParams = {
      source: queryParams.get(UtmParams.Source) || "",
      medium: queryParams.get(UtmParams.Medium) || "",
      campaign: queryParams.get(UtmParams.Campaign) || "",
      term: queryParams.get(UtmParams.Term) || "",
      content: queryParams.get(UtmParams.Content) || ""
    };

    if (
      utmParams.source ||
      utmParams.medium ||
      utmParams.campaign ||
      utmParams.term ||
      utmParams.content
    ) {
      return utmParams;
    } else {
      return null;
    }
  }
};

export const fetchBlob = (url, callback) => {
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      callback(blob);
    });
};

export const convertURLToLink = (message) => {
  if (message) {
    let linkRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;

    return message.replace(linkRegex, (match) => {
      let url = match.toLowerCase().startsWith("www.") ? `//${match}` : match;

      if (url.endsWith(".")) {
        url = url.slice(0, url.length - 1);
      }

      return `<a class="message_url" href="${url}" target="_blank" rel="noopener noreferrer">${match}</a>`;
    });
  }
};

export const parseJsonSafely = (inputString) => {
  try {
    return typeof inputString === "string"
      ? JSON.parse(inputString.trim())
      : inputString;
  } catch {
    return inputString;
  }
};

export const AddProtocolInUrl = (url) => {
  if (!/^https?:\/\//i.test(url)) {
    return "https://" + url;
  }
  return url;
};

export const ConvertURLToLink = (str) => {
  if (!str) return str;

  const linkRegex =
    /\b(?:https?|ftp):\/\/[^\s<>]+|(?:www\.)[\w.-]+\.[a-z]{2,6}\b/gi;

  const parts = str.split(linkRegex);
  const matches = str.match(linkRegex);

  if (!matches) return str;

  const result = [];
  parts.forEach((part, i) => {
    result.push(part);
    if (matches[i]) {
      const url = matches[i];
      result.push(
        <a key={i} href={AddProtocolInUrl(url)} target="_blank">
          {url}
        </a>
      );
    }
  });

  return <>{result}</>;
};

const SCREEN_READER_DIGIT_WORDS = [
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine"
];

export function formatCardLast4ForScreenReader(last4) {
  if (last4 == null || last4 === "") {
    return undefined;
  }

  return last4
    .toString()
    .split("")
    .map((char) => {
      if (/[0-9]/.test(char)) {
        return SCREEN_READER_DIGIT_WORDS[Number(char)];
      }

      return char;
    })
    .join(" ");
}

export function formatEmailForScreenReader(email) {
  if (!email) {
    return undefined;
  }

  const specialCharLabels = {
    "@": "at",
    ".": "dot",
    "+": "Plus",
    "-": "dash",
    _: "underscore"
  };

  return email
    .split("")
    .map((char) => {
      if (/[a-z]/i.test(char)) {
        return char.toLowerCase();
      }

      if (/[0-9]/.test(char)) {
        return SCREEN_READER_DIGIT_WORDS[Number(char)];
      }

      return specialCharLabels[char] || char;
    })
    .join(" ");
}

export const SetPageTitle = (title) => {
  document.title = title || PAGE_TITLES.DEFAULT;
};
